function normalize(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function countLeaveDaysInRange(
  userAvailability: { startDate: string; endDate?: string | null }[],
  taskStart: Date,
  taskEnd: Date
): number {
  if (!userAvailability || !userAvailability.length) return 0;

  const rawStart = new Date(taskStart);
  const rawEnd = new Date(taskEnd);

  if (isNaN(rawStart.getTime()) || isNaN(rawEnd.getTime())) {
    return 0;
  }

  // normalize task dates
  const normTaskStart = normalize(rawStart);
  const normTaskEnd = normalize(rawEnd);

  let leaveDays = 0;

  for (const leave of userAvailability) {
    if (!leave?.startDate) continue;
    const rawLeaveStart = new Date(leave.startDate);
    if (isNaN(rawLeaveStart.getTime())) continue;

    const leaveStart = normalize(rawLeaveStart);
    const rawLeaveEnd = leave.endDate ? new Date(leave.endDate) : rawLeaveStart;
    const leaveEnd = !isNaN(rawLeaveEnd.getTime())
      ? normalize(rawLeaveEnd)
      : leaveStart;

    const overlapStart = leaveStart > normTaskStart ? leaveStart : normTaskStart;
    const overlapEnd = leaveEnd < normTaskEnd ? leaveEnd : normTaskEnd;

    if (overlapStart <= overlapEnd) {
      // difference in calendar days
      const diffDays =
        Math.floor(
          (overlapEnd.getTime() - overlapStart.getTime()) / (1000 * 60 * 60 * 24)
        ) + 1;

      leaveDays += diffDays;
    }
  }

  return leaveDays;
}
